import { render, staticRenderFns } from "./Verpreinforme.vue?vue&type=template&id=771ac02b&"
import script from "./Verpreinforme.vue?vue&type=script&lang=js&"
export * from "./Verpreinforme.vue?vue&type=script&lang=js&"
import style0 from "./Verpreinforme.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports